import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';


// FIX: Sadece 3 tip — Vet. Hekim, Bireysel, Bayi
const tipLabel = { vet_hekim: 'Vet. Hekim', bireysel: 'Bireysel', bayi: 'Bayi' };
const tipBadge = { vet_hekim: 'badge-blue', bireysel: 'badge-green', bayi: 'badge-orange' };

export default function Musteriler() {
  const { profil } = useAuth();
  const navigate = useNavigate();
  const [musteriler, setMusteriler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [duzenle, setDuzenle] = useState(null);
  const [arama, setArama] = useState('');
  const [filtreTip, setFiltreTip] = useState('');
  const [filtreSehir, setFiltreSehir] = useState('');
  const [form, setForm] = useState({
    ad: '', telefon: '', email: '', sehir: '', ilce: '',
    bolge: '', adres: '', musteri_tipi: 'vet_hekim', vergi_no: '', vergi_dairesi: '',
  });
  const [filtreFirma, setFiltreFirma] = useState('');
  const [filtreTemsilci, setFiltreTemsilci] = useState('');
  const [filtreIlce, setFiltreIlce] = useState('');
  const [siralama, setSiralama] = useState('ad');
  const [firmalar, setFirmalar] = useState([]);
  const [temsilciler, setTemsilciler] = useState([]);
  const [musteriFiremaMap, setMusteriFiremaMap] = useState({});

  useEffect(() => { fetchMusteriler(); }, []);

  async function fetchMusteriler() {
    let q = supabase.from('musteriler').select('*').eq('aktif', true).order('ad');
    if (profil?.rol === 'temsilci') q = q.eq('temsilci_id', profil.id);
    const [{ data }, { data: firmaData }, { data: siparisData }, { data: temsilciData }] = await Promise.all([
      q,
      supabase.from('firmalar').select('id, ad').eq('aktif', true),
      supabase.from('siparisler').select('musteri_id, firma_id, toplam_tutar'),
      supabase.from('kullanicilar').select('id, ad, soyad').in('rol', ['temsilci', 'admin', 'super_admin']).eq('aktif', true),
    ]);
    setMusteriler(data || []);
    setFirmalar(firmaData || []);
    setTemsilciler(temsilciData || []);

    // Sipariş sayısı ve tutar hesapla
    const sipMap = {};
    (siparisData || []).forEach(s => {
      if (!s.musteri_id) return;
      if (!sipMap[s.musteri_id]) sipMap[s.musteri_id] = { adet: 0, tutar: 0 };
      sipMap[s.musteri_id].adet += 1;
      sipMap[s.musteri_id].tutar += s.toplam_tutar || 0;
    });
    setMusteriler((data || []).map(m => ({ ...m, siparis_adet: sipMap[m.id]?.adet || 0, siparis_tutar: sipMap[m.id]?.tutar || 0 })));
    // Müşteri -> firma listesi map'i oluştur
    const map = {};
    (siparisData || []).forEach(s => {
      if (!s.musteri_id || !s.firma_id) return;
      if (!map[s.musteri_id]) map[s.musteri_id] = new Set();
      map[s.musteri_id].add(s.firma_id);
    });
    setMusteriFiremaMap(map);
    setLoading(false);
  }

  async function handleKaydet() {
    if (!form.ad) return;
    const payload = { ...form, temsilci_id: profil?.id };
    if (duzenle) {
      await supabase.from('musteriler').update(payload).eq('id', duzenle);
    } else {
      await supabase.from('musteriler').insert(payload);
    }
    setModal(false);
    fetchMusteriler();
  }

  async function handleSil(id) {
    if (!window.confirm('Bu müşteriyi silmek istediğinizden emin misiniz?')) return;
    await supabase.from('musteriler').delete().eq('id', id);
    fetchMusteriler();
  }

  function duzenleAc(m) {
    setForm({
      ad: m.ad, telefon: m.telefon || '', email: m.email || '',
      sehir: m.sehir || '', ilce: m.ilce || '', bolge: m.bolge || '',
      adres: m.adres || '', musteri_tipi: m.musteri_tipi, vergi_no: m.vergi_no || '',
      vergi_dairesi: m.vergi_dairesi || '',
    });
    setDuzenle(m.id);
    setModal(true);
  }

  const sehirler = [
    'Adana','Adıyaman','Afyonkarahisar','Ağrı','Amasya','Ankara','Antalya','Artvin',
    'Aydın','Balıkesir','Bilecik','Bingöl','Bitlis','Bolu','Burdur','Bursa','Çanakkale',
    'Çankırı','Çorum','Denizli','Diyarbakır','Edirne','Elazığ','Erzincan','Erzurum',
    'Eskişehir','Gaziantep','Giresun','Gümüşhane','Hakkari','Hatay','Isparta','Mersin',
    'İstanbul','İzmir','Kars','Kastamonu','Kayseri','Kırklareli','Kırşehir','Kocaeli',
    'Konya','Kütahya','Malatya','Manisa','Kahramanmaraş','Mardin','Muğla','Muş',
    'Nevşehir','Niğde','Ordu','Rize','Sakarya','Samsun','Siirt','Sinop','Sivas',
    'Tekirdağ','Tokat','Trabzon','Tunceli','Şanlıurfa','Uşak','Van','Yozgat','Zonguldak',
    'Aksaray','Bayburt','Karaman','Kırıkkale','Batman','Şırnak','Bartın','Ardahan',
    'Iğdır','Yalova','Karabük','Kilis','Osmaniye','Düzce'
  ].sort((a, b) => a.localeCompare(b, 'tr'));
  const ilceler = [...new Set(musteriler.filter(m => !filtreSehir || m.sehir === filtreSehir).map(m => m.ilce).filter(Boolean))].sort();
  const filtreli = musteriler.filter(m => {
    if (arama && !m.ad.toLowerCase().includes(arama.toLowerCase()) && !(m.telefon || '').includes(arama)) return false;
    if (filtreTip && m.musteri_tipi !== filtreTip) return false;
    if (filtreSehir && (m.sehir || '').toLowerCase() !== filtreSehir.toLowerCase()) return false;
    if (filtreFirma && !(musteriFiremaMap[m.id]?.has(filtreFirma))) return false;
    if (filtreTemsilci && m.temsilci_id !== filtreTemsilci) return false;
    if (filtreIlce && (m.ilce || '').toLowerCase() !== filtreIlce.toLowerCase()) return false;
    return true;
  }).sort((a, b) => {
    if (siralama === 'siparis') return (b.siparis_adet || 0) - (a.siparis_adet || 0);
    if (siralama === 'tutar') return (b.siparis_tutar || 0) - (a.siparis_tutar || 0);
    return a.ad.localeCompare(b.ad, 'tr');
  });

  async function excelExport() {
    const XLSX = await import("xlsx");
    const rows = filtreli.map(m => ({
      'Ad': m.ad, 'Telefon': m.telefon, 'Şehir': m.sehir,
      'Tip': tipLabel[m.musteri_tipi] || m.musteri_tipi,
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Müşteriler');
    XLSX.writeFile(wb, 'musteriler.xlsx');
  }

  return (
    <div>
      {/* BAŞLIK */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div>
          <h1 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>Müşteriler</h1>
          <p style={{ fontSize: 12, color: 'var(--text2)', margin: 0 }}>{filtreli.length} müşteri</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-ghost btn-sm" onClick={excelExport}>📊</button>
          <button className="btn btn-primary btn-sm" onClick={() => {
            setForm({ ad: '', telefon: '', email: '', sehir: '', ilce: '', bolge: '', adres: '', musteri_tipi: 'vet_hekim', vergi_no: '', vergi_dairesi: '' });
            setDuzenle(null);
            setModal(true);
          }}>+ Yeni</button>
        </div>
      </div>

      {/* FİLTRELER */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 12 }}>
        <input className="input" placeholder="Ad veya telefon ara..." value={arama} onChange={e => setArama(e.target.value)} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <select className="select" value={filtreTip} onChange={e => setFiltreTip(e.target.value)}>
            <option value="">Tüm Tipler</option>
            <option value="vet_hekim">Vet. Hekim</option>
            <option value="bireysel">Bireysel</option>
            <option value="bayi">Bayi</option>
          </select>
          <select className="select" value={filtreSehir} onChange={e => { setFiltreSehir(e.target.value); setFiltreIlce(''); }}>
            <option value="">Tüm Şehirler</option>
            {sehirler.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <select className="select" value={filtreIlce} onChange={e => setFiltreIlce(e.target.value)} disabled={ilceler.length === 0}>
          <option value="">Tüm İlçeler</option>
          {ilceler.map(i => <option key={i} value={i}>{i}</option>)}
        </select>
        <select className="select" value={filtreFirma} onChange={e => setFiltreFirma(e.target.value)}>
          <option value="">Tüm Firmalar</option>
          {firmalar.map(f => <option key={f.id} value={f.id}>{f.ad}</option>)}
        </select>
        {profil?.rol !== 'temsilci' && (
          <select className="select" value={filtreTemsilci} onChange={e => setFiltreTemsilci(e.target.value)}>
            <option value="">Tüm Temsilciler</option>
            {temsilciler.map(t => <option key={t.id} value={t.id}>{t.ad} {t.soyad}</option>)}
          </select>
        )}
        <select className="select" value={siralama} onChange={e => setSiralama(e.target.value)}>
          <option value="ad">Ada Göre</option>
          <option value="siparis">En Çok Sipariş</option>
          <option value="tutar">En Çok Harcayan</option>
        </select>
        {(arama || filtreTip || filtreSehir || filtreIlce || filtreFirma || filtreTemsilci) && (
          <button className="btn btn-ghost btn-sm" onClick={() => { setArama(''); setFiltreTip(''); setFiltreSehir(''); setFiltreIlce(''); setFiltreFirma(''); setFiltreTemsilci(''); }}>✕ Temizle</button>
        )}
      </div>

      {/* LİSTE */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Yükleniyor...</div>
      ) : filtreli.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Müşteri bulunamadı</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {filtreli.map(m => (
            <div key={m.id} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: '10px 12px' }}>
              {/* Üst satır: isim + tip badge + butonlar */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div
                  onClick={() => navigate(`/musteriler/${m.id}`)}
                  style={{ cursor: 'pointer', flex: 1, minWidth: 0 }}
                >
                  <div style={{ fontWeight: 600, fontSize: 14, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{m.ad}</div>
                  <div style={{ fontSize: 12, color: 'var(--text2)' }}>{m.telefon || '-'} • {m.sehir || '-'}</div>
                  {m.siparis_adet > 0 && (
                    <div style={{ fontSize: 11, color: 'var(--accent)', marginTop: 2 }}>
                      {m.siparis_adet} sipariş • {(m.siparis_tutar || 0).toLocaleString('tr-TR')} ₺
                    </div>
                  )}
                </div>

                {/* FIX: Kompakt buton grubu - sağda */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 8, flexShrink: 0 }}>
                  <span className={`badge ${tipBadge[m.musteri_tipi] || 'badge-gray'}`} style={{ fontSize: 10 }}>
                    {tipLabel[m.musteri_tipi] || m.musteri_tipi}
                  </span>
                  <button
                    className="btn btn-ghost btn-sm"
                    style={{ padding: '3px 8px', fontSize: 12 }}
                    onClick={() => navigate(`/musteriler/${m.id}`)}
                  >Detay</button>
                  <button
                    className="btn btn-ghost btn-sm"
                    style={{ padding: '3px 8px', fontSize: 12 }}
                    onClick={() => duzenleAc(m)}
                  >✏️</button>
                  <button
                    className="btn btn-danger btn-sm"
                    style={{ padding: '3px 8px', fontSize: 12 }}
                    onClick={() => handleSil(m.id)}
                  >🗑</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* MODAL */}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" style={{ maxWidth: 500 }} onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">{duzenle ? 'Müşteri Düzenle' : 'Yeni Müşteri'}</h3>

            <div className="form-group">
              <label className="label">Ad Soyad / Klinik Adı *</label>
              <input className="input" value={form.ad} onChange={e => setForm(f => ({ ...f, ad: e.target.value }))} autoFocus />
            </div>

            {/* FIX: Sadece 3 tip */}
            <div className="form-group">
              <label className="label">Müşteri Tipi</label>
              <select className="select" value={form.musteri_tipi} onChange={e => setForm(f => ({ ...f, musteri_tipi: e.target.value }))}>
                <option value="vet_hekim">Vet. Hekim</option>
                <option value="bireysel">Bireysel</option>
                <option value="bayi">Bayi</option>
              </select>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div className="form-group">
                <label className="label">Telefon</label>
                <input className="input" value={form.telefon} onChange={e => setForm(f => ({ ...f, telefon: e.target.value.slice(0, 15) }))} />
              </div>
              <div className="form-group">
                <label className="label">Şehir</label>
                <input className="input" value={form.sehir} onChange={e => setForm(f => ({ ...f, sehir: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="label">İlçe</label>
                <input className="input" value={form.ilce} onChange={e => setForm(f => ({ ...f, ilce: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="label">Bölge</label>
                <input className="input" value={form.bolge} onChange={e => setForm(f => ({ ...f, bolge: e.target.value }))} />
              </div>
            </div>

            <div className="form-group">
              <label className="label">Adres</label>
              <textarea className="textarea" value={form.adres} onChange={e => setForm(f => ({ ...f, adres: e.target.value }))} />
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-ghost" onClick={() => setModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={handleKaydet} disabled={!form.ad}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
